import React from 'react';
import { Box } from '@mui/material';
import { NavBar } from '../NavBar';
import { Sidebar } from './Sidebar';
import { tokens } from '../../theme';

export const AppLayout: React.FC<{ children: React.ReactNode; isAdmin?: boolean }> = ({ children, isAdmin }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: tokens.color.bg }}>
      <NavBar />
      <Box sx={{ display: 'flex' }}>
        <Sidebar isAdmin={isAdmin} />
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, md: 4 }, maxWidth: 1200, mx: 'auto', width: '100%' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
